import { render, staticRenderFns } from "./AvatarCheckbox.vue?vue&type=template&id=388b8dc6&"
import script from "./AvatarCheckbox.vue?vue&type=script&lang=js&"
export * from "./AvatarCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports